import { isDevMode } from '@angular/core';

import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { Environment } from './env';

export const environment: Environment = {
  imports: [StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode(), connectInZone: true })],
  domain: 'https://bhapi.sandbox.mark.health',
  mainApidomain: 'https://appapi.sandbox.mark.health',
  production: true,
  name: 'sandbox',
  distPath: 'browser',
  cookieAuthDomain: '.sandbox.mark.health',
  cookieUserTokenName: 'mark-health-token-user-Sandbox',
  redirectAuthURL: 'https://auth.sandbox.mark.health/?RedirectUrl=',
  checkoutURL: `https://checkout.sandbox.mark.health/checkout`,
  authUrl: `https://auth.sandbox.mark.health`,
  siteId: `64d99909-ad53-4dc7-9999-09ad537dc7b4`,
  assessmetUrl: `https://offer.sandbox.mark.health/en/questionnaire`,
};
